export default __webpack_public_path__ + "static/media/personality.f1e7a132.png";